var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Template1"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    }
  }, [(_vm.selectedViewRowData.bookingmode == 'To Pay' && _vm.showCashMemoButton == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Upload FTC Cash Memo"
    },
    on: {
      "click": _vm.openFtcModal
    }
  }, [_vm._v("Upload FTC Cash Memo "), _c('i', {
    staticClass: "fa fa-upload"
  })]) : _vm._e(), _vm._v("  \n    "), (_vm.selectedViewRowData.status == 1) ? _c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.printAWBPage
    }
  }, [_vm._v("Print AWB "), _c('i', {
    staticClass: "fa fa-print"
  })]) : _vm._e(), _vm._v("  \n    "), (_vm.selectedViewRowData.status == 1) ? _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.openPrintMPSModal
    }
  }, [_vm._v("Print MPS "), _c('i', {
    staticClass: "fa fa-print"
  })]) : _vm._e(), _vm._v("  \n    "), (_vm.rateCardData) ? _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "title": "View Rate Card"
    },
    on: {
      "click": function($event) {
        _vm.openViewRateCard = true
      }
    }
  }, [_vm._v("View Rate Card "), _c('i', {
    staticClass: "fa fa-credit-card"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-header-tab"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.value) + "\n      "), (tab.value == 'Basic Information') ? _c('span', {
      attrs: {
        "id": "first"
      }
    }, [_c('i', {
      staticClass: "fa fa-info"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'Detailed Information') ? _c('span', {
      attrs: {
        "id": "second"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text-o"
    })]) : _vm._e()])
  })), _vm._v(" "), _c('div', [_c('keep-alive', [_c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    ref: "childBookingViewComponent",
    tag: "component",
    staticClass: "tab",
    attrs: {
      "bookingData": _vm.selectedViewRowData
    }
  })], 1)], 1), _vm._v(" "), (_vm.LRCopyawbdata) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('LR-Copy', {
    attrs: {
      "selectedData": _vm.LRCopyawbdata
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.PrintMPSModal = false
      }
    },
    model: {
      value: (_vm.PrintMPSModal),
      callback: function($$v) {
        _vm.PrintMPSModal = $$v
      },
      expression: "PrintMPSModal"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Print MPS")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePrintMPSModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('printmps', {
    attrs: {
      "bookingdata": _vm.bookingData
    }
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.FtcModal = false
      }
    },
    model: {
      value: (_vm.FtcModal),
      callback: function($$v) {
        _vm.FtcModal = $$v
      },
      expression: "FtcModal"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('b', [_vm._v("Upload/View FTC Cash Memo ")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeFtcModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.allowimageupload == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    attrs: {
      "for": "ftccashmemeo"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    staticStyle: {
      "font-size": "1.5em"
    },
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "ftccashmemeo",
      "name": "ftccashmemeo",
      "accept": ".jpeg,.jpg,.png,.pdf,.doc,.docx",
      "multiple": "multiple",
      "type": "file"
    },
    on: {
      "change": _vm.UploadFtcCashMemo
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v("\n        " + _vm._s(_vm.filename) + "\n      ")]), _vm._v(" "), (_vm.filename) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.clearFtcModal
    }
  }, [_c('strong', [_vm._v("x")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("View Uploaded File\n                    "), _c('div', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v(_vm._s(_vm.downloadmessage))])]), _vm._v(" "), (_vm.uploadedDoc) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "1.5rem",
      "padding-left": "-16",
      "padding-top": "16px"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Download Image"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.uploadedDoc)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "float": "right",
      "padding-right": "16px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Save",
      "disabled": !_vm.filename
    },
    on: {
      "click": function($event) {
        _vm.SaveFtcCashMemo()
      }
    }
  }, [_vm._v(" Save")]), _vm._v("   \n                      "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset",
      "title": "Cancel"
    },
    on: {
      "click": function($event) {
        _vm.closeFtcModal()
      }
    }
  }, [_vm._v("Cancel")])])])])])], 1), _vm._v(" "), (_vm.rateCardData) ? _c('b-modal', {
    attrs: {
      "size": "md"
    },
    model: {
      value: (_vm.openViewRateCard),
      callback: function($$v) {
        _vm.openViewRateCard = $$v
      },
      expression: "openViewRateCard"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_vm._v("\n        Rate Break Up\n        "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.openViewRateCard = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-8-text-center",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Base Freight")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.basefreight).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin Terminal charges ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.originterminalcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Terminal Charges ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.destinationterminalcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Other Charges ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.othercharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Operator Charges origin ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.originoperatorcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Operator Charges destination ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.destinationoperatorcharges.toFixed(2))))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Extra Charge ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(parseFloat(_vm.rateCardData.rate.extracharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center table-warning"
  }, [_vm._v("Total Charge ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center table-warning"
  }, [_vm._v(_vm._s(parseFloat(_vm.totalcharges).toFixed(2)))])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center table-success"
  }, [_vm._v("Total charges + GST (18%) ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center table-success"
  }, [_vm._v(_vm._s(parseFloat(_vm.totalcharges + _vm.gst).toFixed(2)))])])])])])])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243c041b","hasScoped":true}!./src/modules/cargobooking/views/booking/bookingListing/bookingview/bookingview.component.html
// module id = 1199
// module chunks = 3